import axios, { InternalAxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import { authService } from './authService';

// Configuración base de axios
export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3001/api',
  timeout: 60000, // 60 segundos para operaciones bulk e invoices grandes
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para peticiones - Añade el token de autenticación
api.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    try {
      // Obtener el token del usuario actual
      const token = await authService.getCurrentToken();

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    } catch (error) {
      console.error('Error obteniendo token en interceptor:', error);
      return config;
    }
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Interceptor para respuestas - Manejo de errores
api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      // Log del error para debugging
      console.error('Error 401:', error.response?.data);

      // Solo redirigir a login si es un error de autenticación inicial
      // No redirigir si ya estamos en login o si es un error de operación
      const isAuthEndpoint = error.config?.url?.includes('/auth/');
      const isLoginPage = window.location.pathname === '/login';

      if (!isLoginPage && isAuthEndpoint) {
        // Si el token expiró o no es válido, limpiar y redirigir a login
        localStorage.removeItem('auth-storage');
        localStorage.removeItem('authToken');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('userId');
        window.location.href = '/login';
      }
    }

    // Manejo adicional de errores
    if (error.response?.status === 403) {
      console.error('Acceso denegado: No tienes permisos para esta acción');
    }

    if (error.response?.status === 429) {
      console.error('Demasiadas solicitudes: Por favor, espera un momento');
    }

    if (error.response && error.response.status >= 500) {
      console.error('Error del servidor: Intenta de nuevo más tarde');
    }

    return Promise.reject(error);
  }
);

export default api;
